import React from "react";
import SvgIcon from "react-icons-kit";
import { Tooltip } from "reactstrap";
import TooltipContainer from "../../libraries/TooltipContainer";

export const SectionActionArea = ({ actions, data }) => {
  return (
    <div>
      {actions &&
        actions.map((a) => {
          if (a.visibleCondition && !a.visibleCondition(data)) return null;
       
          let toRender = a.button ? (
            <ButtonObj callback={a.callback} name={a.name} button={a.button} data={data} />
          ) : a.icon ? (
            <IconObj callback={a.callback} icon={a.icon} data={data} />
          ) : null;
          return (
            <TooltipContainer tooltipText={a.toolTip}> 
            <div className="s_ac_area" key={a.id}>
              {toRender}
            </div>
            </TooltipContainer>
          );
       
        })}
    </div>
  );
};

const ButtonObj = ({ button, callback, data, name }) => {
  let conditionStyle = {};
  if (button.conditionStyle) conditionStyle = button.conditionStyle(data);
  return (
    <button
      style={conditionStyle}
      onClick={(e) => {
        callback(data);
      }}
    >
      {name}
    </button>
  );
};

const IconObj = ({ icon, callback, data }) => {
  let conditionStyle = {};
  let iconToSet = icon.icon;
  if (icon.conditionIcon) {
    iconToSet = icon.conditionIcon(data);
  }
  if (icon.conditionStyle) conditionStyle = icon.conditionStyle(data);
  return (
    <div
      style={conditionStyle}
      onClick={(e) => {
        callback(data);
      }}
      className="s_ac_icon_c"
    >
      <SvgIcon size={20} icon={iconToSet} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Sections/SectionActionArea.js